export function get(key, cookies = document.cookie) {
    if (!key) {
        return null;
    }
    return decodeURIComponent(cookies.replace(new RegExp(`(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`), '$1')) || null;
}

export function set(key, val, end, domain, secure, sameSite) {
    if (!key || /^(expires|max-age|path|domain|secure)$/i.test(key)) {
        return false;
    }

    let expires = '';
    if (end) {
        switch (end.constructor) {
            case Number:
                expires = end === Infinity
                    ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                    : `; max-age=${end}`;
                break;
            case String:
                expires = `; expires=${end}`;
                break;
            case Date:
                expires = `; expires=${end.toUTCString()}`;
                break;
        }
    }

    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(val)}${expires}${domain ? `; domain=${domain}` : ''}${secure ? '; secure' : ''}${sameSite ? `; SameSite=${sameSite}` : ''}; path=/`;
    return true;
}
